import * as basket from "../eaiws/basket";
import { SceneElement } from "../core/mdl/SceneElement";
import { ERR_INVALID_STATE, rejectError } from "../utils/error";
import { AppModule } from "./AppModule";
import { MainArticleElement } from "./MainArticleElement";
export class UserArticleElement extends MainArticleElement {
    updateGeometry(pValidateSelection = true) {
        return (Promise.resolve());
    }
    clone(pNewParent = null) {
        const tClone = new UserArticleElement(null, this.mMngr, SceneElement.cloneNode(this.mNode, pNewParent));
        tClone.copyDataFrom(this);
        return (tClone);
    }
    serialize(pContext) {
        if (this.mNode == null)
            return (null);
        const tIOArticle = super.serialize(pContext);
        tIOArticle.classId = UserArticleElement.CLASS_ID; //override classId
        return (tIOArticle);
    }
    //// internal //////////////////////////////////////////////////////////////////////////////
    /** @internal **/
    _getCatalogImageUrl(pBasketId) {
        return (Promise.resolve(null));
    }
    /** @internal */
    static _LoadArticleElement(pApp, pContext, pIOElement) {
        if (pIOElement == null)
            return (null);
        const tIOArticle = pIOElement;
        let tIsPlaceholder = tIOArticle.placeholderGeometry != null ?
            tIOArticle.placeholderGeometry : false;
        const tModule = pApp.getModule(AppModule.MODULE_KEY);
        const tLoadedNode = MainArticleElement.LoadArticleElementNode(pApp, pContext, pIOElement);
        if (tLoadedNode == null || tLoadedNode.basketId == null || tModule == null)
            return (null);
        const tUserArticle = new UserArticleElement(tLoadedNode.basketId, tModule.articleManager, tLoadedNode.node);
        if (tUserArticle.mNode == null)
            tIsPlaceholder = true;
        //register geometry task
        if (tIsPlaceholder)
            pContext.registerPendingTask(() => tUserArticle._initPlaceholderGeometry(null));
        return (tUserArticle);
    }
    /** @internal */
    _resetImpGeometry() {
        if (this.mBasketId == null)
            return (rejectError(ERR_INVALID_STATE, "basketId is null"));
        //reset in cache
        const tCachedProps = this.getCachedItemProperties();
        if (tCachedProps != null && tCachedProps.composableGeometry != null)
            tCachedProps.composableGeometry.geometry = "";
        //reset on eaiws
        const tProps = new basket.ItemProperties();
        tProps.composableGeometry = new basket.ComposableGeometryProperties();
        tProps.composableGeometry.geometry = "";
        return (this.mMngr.session.basket.setItemProperties(this.mBasketId, tProps));
    }
    //// protected /////////////////////////////////////////////////////////////////////////////
    supportScaleEaiwsTransform() {
        return (true);
    }
}
UserArticleElement.CLASS_ID = "egr.wcf.cf:UserArticle";
